const useView = () => {
  const search = document.location.hash.split("?")[1];
  const params = new URLSearchParams(search);
  const filter = JSON.parse(params.get("filter") || "{}");
  const view = filter?.view === 1;
  return view;
};

export default useView;
